import React from 'react';
import SEO from '../components/SEO';

export default function PrivacyPolicyPage() {
    return (
        <div className="container-page py-12 max-w-4xl text-slate-700 dark:text-slate-300">
            <SEO
                title="Privacy Policy"
                description="Learn how AuraIcon collects, uses, and protects your personal information. Our privacy policy explains data handling practices."
                canonical="/privacy"
            />
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-8">Privacy Policy</h1>

            <div className="space-y-8">
                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">1. Information We Collect</h2>
                    <p className="leading-relaxed mb-4">
                        We collect information you provide directly to us, such as when you create an account, make a purchase, or communicate with us. This may include:
                    </p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><strong>Personal Information:</strong> Name, email address, and account credentials (managed via Auth0).</li>
                        <li><strong>Usage Data:</strong> Information about how you use our website, including log data and device information (using Google Analytics).</li>
                        <li><strong>User Content:</strong> Text prompts and generated images you create using our service.</li>
                        <li><strong>Payment Information:</strong> Transaction details processed securely by our payment provider, Paddle. We do not store full credit card numbers.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">2. How We Use Your Information</h2>
                    <p className="leading-relaxed mb-4">
                        We use the information we collect to:
                    </p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li>Provide, maintain, and improve our services.</li>
                        <li>Process transactions and send related information, including confirmations and invoices.</li>
                        <li>Send you technical notices, updates, security alerts, and support messages.</li>
                        <li>Monitor and analyze trends, usage, and activities in connection with our services.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">3. Third-Party Services</h2>
                    <p className="leading-relaxed">
                        We share information with third-party vendors, consultants, and other service providers who need access to such information to carry out work on our behalf:
                    </p>
                    <ul className="list-disc pl-5 mt-2 space-y-2">
                        <li><strong>Auth0:</strong> For authentication and user management.</li>
                        <li><strong>Paddle:</strong> For payment processing and order fulfillment.</li>
                        <li><strong>Google Analytics:</strong> To understand how our services are used.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">4. Data Security</h2>
                    <p className="leading-relaxed">
                        We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-slate-900 dark:text-white mb-4">5. Contact Us</h2>
                    <p className="leading-relaxed">
                        If you have any questions about this Privacy Policy, please contact us at:
                        <br />
                        <strong>Bridge Apps LLC</strong>
                        <br />
                        Email: <a href="mailto:michael@bridgeappsllc.com" className="text-violet-600 dark:text-violet-400 hover:underline">michael@bridgeappsllc.com</a>
                    </p>
                </section>

                <p className="text-sm text-slate-500 mt-12 pt-8 border-t border-slate-200 dark:border-white/10">
                    Last updated: {new Date().toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}
